import axios from "axios"
import VueCookie from "vue-cookie"
import { constants } from "@/config/constants"

let apiUrl = constants.API_URL
let token = process.env.VUE_APP_APP_CHECKLIST_ACCESS_TOKEN

const api = axios.create({
  baseURL: apiUrl,
  headers: {
    common: {
      Authorization: `Bearer ${VueCookie.get("__kursweblara_access_token")}`
    }
  }
})
const checklistApi = axios.create({
  baseURL: process.env.VUE_APP_APP_CHECKLIST_URL,
  headers: {
    common: {
      "X-AccessToken": token
    }
  }
})
// eslint-disable-next-line
const document_url = process.env.VUE_APP_APP_CHECKLIST_URL.replace("api/", "")
// eslint-disable-next-line
export { api, checklistApi, document_url }
